import styled from 'styled-components';
import tw, { classnames, position, backgroundSize, margin, padding, flexWrap, height, backgroundPosition, textAlign, fontSize, width, display, alignContent } from 'tailwindcss-classnames';

const classnameBase = classnames(position('relative'), backgroundSize('bg-cover'), margin('my-0'), padding('pt-10', 'pb-6'), flexWrap('flex-wrap'));

const getHeightSize = (size: 'sm' | 'lg' = 'lg') => {
    if (size === 'sm') {
        return classnames(height('h-56', 'md:h-56', 'lg:h-56'));
    }
    return classnames(height('h-68' as any, 'sm:h-68' as any, 'lg:h-84' as any, 'md:h-40'));
}

export const ImageContainer = (heightSize?: 'sm' | 'lg') => styled.div.attrs({
    className: classnames(getHeightSize(heightSize), 'bg-title' as any, 'bg-gpas-700' as any, '-mt-20' as any),
})``;

export const ImageChild = (imageUrl: string) => styled.div.attrs({
    className: classnames(classnameBase, 'child' as any, backgroundSize('bg-cover'), backgroundPosition('bg-center')),
})`
    background-image: linear-gradient(rgba(0,0,0,0.1), rgba(0, 0, 10, 0.9) ), url('${imageUrl}');
    width: 100%;
    height: 100%;
`;

export const MarkdonwClass = styled.div.attrs({
    className: classnames(position('relative'), textAlign('text-justify'), fontSize('text-lg'))
})``;

export const OptionsContainer = styled.div.attrs({
    className: classnames(width('w-full'), display('flex'), alignContent('content-between'), padding('py-4'))
})``;
